var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6832 4.86719L31.5165 9.23385C34.3499 10.4839 34.3499 12.5505 31.5165 13.8005L21.6832 18.1672C20.5665 18.6672 18.7332 18.6672 17.6165 18.1672L7.7832 13.8005C4.94987 12.5505 4.94987 10.4839 7.7832 9.23385L17.6165 4.86719C18.7332 4.36719 20.5665 4.36719 21.6832 4.86719Z",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.334C5 19.734 6.05 21.3507 7.33333 21.9173L18.65 26.9507C19.5167 27.334 20.5 27.334 21.35 26.9507L32.6667 21.9173C33.95 21.3507 35 19.734 35 18.334",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 26.666C5 28.216 5.91667 29.616 7.33333 30.2493L18.65 35.2827C19.5167 35.666 20.5 35.666 21.35 35.2827L32.6667 30.2493C34.0833 29.616 35 28.216 35 26.666",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackIcon);
export default __webpack_public_path__ + "static/media/StackIcon.93291e9bdc313642bbe9f7129b99097b.svg";
export { ForwardRef as ReactComponent };